/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import { RoleFieldsFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListUsersAccessedByQueryVariables = Types.Exact<{
  user_id: Types.Scalars['String']['input'];
}>;


export type ListUsersAccessedByQuery = { __typename?: 'Query', getUserRecord: { __typename?: 'UserModel', user_id: string, accessed_by?: Array<{ __typename?: 'UserModel', user_id: string, email?: string | null, first_name: string, last_name: string, profile_picture?: string | null, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string } | null }> | null } };

export type ListAccessManagementUsersQueryVariables = Types.Exact<{
  user_id: Types.Scalars['String']['input'];
}>;


export type ListAccessManagementUsersQuery = { __typename?: 'Query', getAccessManagement: { __typename?: 'UserModel', user_id: string, account: { __typename?: 'AccountModel', account_id: string, users: Array<{ __typename?: 'UserModel', user_id: string, account_id: string, email?: string | null, first_name: string, middle_name?: string | null, last_name: string, profile_picture?: string | null, access_level?: { __typename?: 'UserAccess', level: Types.UserAccessLevel, scopes: Array<Types.PermissionScope> } | null, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, patient_id: string } | null, roles: Array<{ __typename?: 'RoleModel', created_user_id?: string | null, created_at: string, updated_at: string, role_description: string, role_id: string, role_name: string }> }> }, accessed_by?: Array<{ __typename?: 'UserModel', user_id: string, account_id: string, email?: string | null, first_name: string, middle_name?: string | null, last_name: string, profile_picture?: string | null, access_level?: { __typename?: 'UserAccess', level: Types.UserAccessLevel, scopes: Array<Types.PermissionScope> } | null, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, patient_id: string } | null, roles: Array<{ __typename?: 'RoleModel', role_id: string, role_name: string, role_description: string, rank?: number | null, scope?: Types.AccountType | null, created_at: string, updated_at: string }> }> | null } };


export const ListUsersAccessedByDocument = gql`
    query listUsersAccessedBy($user_id: String!) {
  getUserRecord(input: {user_id: $user_id}) {
    user_id
    accessed_by {
      user_id
      email
      first_name
      last_name
      user_id
      profile_picture
      vitall_patient {
        vitall_patient_id
      }
    }
  }
}
    `;
export function useListUsersAccessedByQuery(baseOptions: Apollo.QueryHookOptions<ListUsersAccessedByQuery, ListUsersAccessedByQueryVariables> & ({ variables: ListUsersAccessedByQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersAccessedByQuery, ListUsersAccessedByQueryVariables>(ListUsersAccessedByDocument, options);
      }
export function useListUsersAccessedByLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersAccessedByQuery, ListUsersAccessedByQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersAccessedByQuery, ListUsersAccessedByQueryVariables>(ListUsersAccessedByDocument, options);
        }
// @ts-ignore
export function useListUsersAccessedBySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListUsersAccessedByQuery, ListUsersAccessedByQueryVariables>): Apollo.UseSuspenseQueryResult<ListUsersAccessedByQuery, ListUsersAccessedByQueryVariables>;
export function useListUsersAccessedBySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUsersAccessedByQuery, ListUsersAccessedByQueryVariables>): Apollo.UseSuspenseQueryResult<ListUsersAccessedByQuery | undefined, ListUsersAccessedByQueryVariables>;
export function useListUsersAccessedBySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUsersAccessedByQuery, ListUsersAccessedByQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUsersAccessedByQuery, ListUsersAccessedByQueryVariables>(ListUsersAccessedByDocument, options);
        }
export type ListUsersAccessedByQueryHookResult = ReturnType<typeof useListUsersAccessedByQuery>;
export type ListUsersAccessedByLazyQueryHookResult = ReturnType<typeof useListUsersAccessedByLazyQuery>;
export type ListUsersAccessedBySuspenseQueryHookResult = ReturnType<typeof useListUsersAccessedBySuspenseQuery>;
export type ListUsersAccessedByQueryResult = Apollo.QueryResult<ListUsersAccessedByQuery, ListUsersAccessedByQueryVariables>;
export const ListAccessManagementUsersDocument = gql`
    query listAccessManagementUsers($user_id: String!) {
  getAccessManagement(input: {user_id: $user_id}) {
    user_id
    account {
      account_id
      users {
        user_id
        account_id
        email
        first_name
        middle_name
        last_name
        profile_picture
        access_level(user_id: $user_id) {
          level
          scopes
        }
        vitall_patient {
          vitall_patient_id
          patient_id
        }
        roles {
          created_user_id
          created_at
          updated_at
          role_description
          role_id
          role_name
        }
      }
    }
    accessed_by {
      user_id
      account_id
      email
      first_name
      middle_name
      last_name
      profile_picture
      access_level(user_id: $user_id) {
        level
        scopes
      }
      vitall_patient {
        vitall_patient_id
        patient_id
      }
      roles {
        ...RoleFields
      }
    }
  }
}
    ${RoleFieldsFragmentDoc}`;
export function useListAccessManagementUsersQuery(baseOptions: Apollo.QueryHookOptions<ListAccessManagementUsersQuery, ListAccessManagementUsersQueryVariables> & ({ variables: ListAccessManagementUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAccessManagementUsersQuery, ListAccessManagementUsersQueryVariables>(ListAccessManagementUsersDocument, options);
      }
export function useListAccessManagementUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAccessManagementUsersQuery, ListAccessManagementUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAccessManagementUsersQuery, ListAccessManagementUsersQueryVariables>(ListAccessManagementUsersDocument, options);
        }
// @ts-ignore
export function useListAccessManagementUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAccessManagementUsersQuery, ListAccessManagementUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ListAccessManagementUsersQuery, ListAccessManagementUsersQueryVariables>;
export function useListAccessManagementUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAccessManagementUsersQuery, ListAccessManagementUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ListAccessManagementUsersQuery | undefined, ListAccessManagementUsersQueryVariables>;
export function useListAccessManagementUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAccessManagementUsersQuery, ListAccessManagementUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAccessManagementUsersQuery, ListAccessManagementUsersQueryVariables>(ListAccessManagementUsersDocument, options);
        }
export type ListAccessManagementUsersQueryHookResult = ReturnType<typeof useListAccessManagementUsersQuery>;
export type ListAccessManagementUsersLazyQueryHookResult = ReturnType<typeof useListAccessManagementUsersLazyQuery>;
export type ListAccessManagementUsersSuspenseQueryHookResult = ReturnType<typeof useListAccessManagementUsersSuspenseQuery>;
export type ListAccessManagementUsersQueryResult = Apollo.QueryResult<ListAccessManagementUsersQuery, ListAccessManagementUsersQueryVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useListUsersAccessedBy = withQueryResponseHandler(useListUsersAccessedByQuery);
export const useListAccessManagementUsers = withQueryResponseHandler(useListAccessManagementUsersQuery);
